import experimentApiFactory from '../../modules/experiment/experimentApi';

/* Utils */
import {
  generateDefaultAsyncWatcher,
  generateDefaultAsyncSaga,
} from '../core/reduxUtils';

/* Actions */
import {
  getAppExperimentsActionCreators, getDesktopSearchExperimentsActionCreators, getSearchExperimentsActionCreators,
} from '../actions/experimentActions';

function experimentSagasFactory({storefrontApiClient}) {
  const experimentApi = experimentApiFactory(storefrontApiClient);

  const getAppExperimentsSaga = generateDefaultAsyncSaga(
    experimentApi.getExperiments,
    getAppExperimentsActionCreators,
    payload => [
      payload.params,
    ]
  );

  const getSearchExperimentsSaga = generateDefaultAsyncSaga(
    experimentApi.getExperiments,
    getSearchExperimentsActionCreators,
    payload => [
      payload.params,
    ]
  );

  const getDesktopSearchExperimentsSaga = generateDefaultAsyncSaga(
    experimentApi.getExperiments,
    getDesktopSearchExperimentsActionCreators,
    payload => [
      payload.params,
    ]
  );

  const watchGetAppExperiments = generateDefaultAsyncWatcher(
    'GET_APP_EXPERIMENTS',
    getAppExperimentsSaga,
  );

  const watchGetSearchExperiments = generateDefaultAsyncWatcher(
    'GET_SEARCH_EXPERIMENTS',
    getSearchExperimentsSaga,
  );

  const watchGetDesktopSearchExperiments = generateDefaultAsyncWatcher(
    'GET_DESKTOP_SEARCH_EXPERIMENTS',
    getDesktopSearchExperimentsSaga,
  );

  const experimentSagas = [
    watchGetAppExperiments(),
    watchGetSearchExperiments(),
    watchGetDesktopSearchExperiments(),
  ];

  return experimentSagas;
}

export default experimentSagasFactory;
